// extracted by mini-css-extract-plugin
module.exports = {"base":"FooterRoutes_base__Fgv4g","divider":"FooterRoutes_divider__FlEbz"};